var _style, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPen = function SvgPen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pen_svg__\\uB808\\uC774\\uC5B4_1",
    fill: "currentColor",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".pen_svg__st1{fill:none;stroke-linecap:round;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "pen_svg__st0",
    d: "m7.05 22.97-5.9 1.19A.978.978 0 0 1 0 23.01l1.19-5.9 5.86 5.86z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-44.992 11.356 12.815)",
    className: "pen_svg__st0",
    d: "M3.18 8.67h16.35v8.29H3.18z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "pen_svg__st0",
    d: "m17.87.43-2.21 2.21 5.86 5.86 2.21-2.21c.38-.38.38-1 0-1.38L19.25.43c-.38-.38-1-.38-1.38 0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "pen_svg__st1",
    d: "M23.5 23.67H11.54M23.5 21.52h-7.84"
  })));
};
export default SvgPen;